import type { FC } from "react";
import type { CustomRef } from "@/utils/types";
import type { ValueOf } from "@/utils/valueOf";
import type { ButtonProps } from "../button/types";

export const ProductContainerSpacing = {
  WIDE: "wide",
  NARROW: "narrow",
  WIDER: "wider",
} as const;
export type ProductContainerSpacing = ValueOf<typeof ProductContainerSpacing>;

// Props type for all container components
export type ProductContainerProps = {
  children: React.ReactNode;
  className?: string;
} & CustomRef<HTMLDivElement>;

export type SectionProductContainerProps = {
  spacing?: ProductContainerSpacing;
  divider?: boolean;
  showSection?: boolean;
  label?: string | null;
} & ProductContainerProps;

export type SectionProps = {
  title?: string | null;
  component: React.ReactNode;
  divider?: boolean;
};

export type TopQuestionsContainerProps = {
  topSection: SectionProps;
  bottomSection: SectionProps;
};

export interface ProductContainerComponent extends FC<ProductContainerProps> {
  Section: FC<SectionProductContainerProps>;
  Entry: FC<ProductContainerProps>;
  CallToAction: FC<ButtonProps>;
  Loader: FC;
  Form: FC<React.FormHTMLAttributes<HTMLFormElement>>;
  TopQuestions: FC<TopQuestionsContainerProps>;
}
